/**
 * Gestion des changements de page smooth
 * Nous utilisons Barba.js pour faire ceci
 * http://barbajs.org/
 */
class SmoothPagesTransition{

    /**
     *
     */
    constructor(Bulb){
        Utils.debug('Construct SmoothPage');
        this.bulb = Bulb;
				this.newClassesToInject = '';
				this.elementorsCssToInject = '';
		}


    /**
     *
     */
    init(){
        let self = this;

        Barba.Pjax.start();
        Barba.Pjax.getTransition = function() {
            return self.pageTransition();
        };

        Barba.Dispatcher.on('initStateChange', function(currentStatus) {
            Utils.debug('loading new page');
        });

        Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container, newPageRawHTML) {
					Utils.debug('new page ready');
					let htmlObject = document.createElement('html');
					htmlObject.innerHTML = newPageRawHTML;
					self.newClassesToInject  = htmlObject.querySelector("body").className;
					self.elementorsCssToInject = $(htmlObject).find('#elementor-frontend-inline-css').html();
				});
    }

    /**
     * Transition de disparition par defaut de Bulb
     * Pas glop, mais c'est du vite fait bien fait
     * @param elt
     * @returns {Promise}
     */
    pageDefaultCleanTransition(elt){
        return new Promise(function(resolve){
            var $loader = $('.loader-slices');
            TweenMax.set($loader, {display: 'block'});
            var t = new TimelineMax({ paused: true, onComplete: function(){ resolve(true) }});
            t.staggerTo($loader.find('span'), 0.3, {scaleY: 1}, 0.05);
            t.play();
        })
    }


    /**
     * Transition d'apparition par defaut de Bulb
     * Pas glop, mais c'est du vite fait bien fait
     * @param elt
     * @param BarbaBaseTrantion
     */
    pageDefaultAppearTransition(elt, BarbaBaseTrantion){

        TweenMax.set($(elt), {visibility : 'visible', opacity : 1});
        var $loader = $('.loader-slices');
        var t = new TimelineMax({ paused: true, onComplete: function(){ BarbaBaseTrantion.done(); TweenMax.set($loader, {display: 'none'}); }});
        t.staggerTo($loader.find('span'), 0.3, {scaleY: 0}, 0.05);
        t.play();
    }


    /**
     *
     * @returns {*|Object}
     */
    pageTransition(){
        var self = this;

        return Barba.BaseTransition.extend({


            start: function() {
                var _this = this;

                Utils.debug('page transition : start');
                self.bulb.menu.close();
                self.bulb.openLoader();

                Promise
                    .all([this.newContainerLoading, _this.clearCurrentPage()])
                    .then( this.loadNextPageAssets.bind(this) );


            },


            /**
             *
             */
            clearCurrentPage: function(){
                let _this = this;
                let cleaningTransition = self.pageDefaultCleanTransition(_this.oldContainer);
                Utils.debug('pageTransition : clearCurrentPage');
                return cleaningTransition;
            },


            /**
             *
             */
            loadNextPageAssets: function(){
                Utils.debug('pageTransition : loadNextPageAssets    ');
								// on switch la classe du bosy
								$('body').removeClass().addClass(self.newClassesToInject);
								// on charge les styles iliens d'elementor
								$('#elementor-frontend-inline-css').html(self.elementorsCssToInject);

							let _this = this;
                let preloadAssetsPromise = self.bulb.preloadAssets();
                preloadAssetsPromise.then(function(){
                    _this.buildNextPage();
                });

            },






            buildNextPage: function() {
                var _this = this;

                Utils.debug('pageTransition : buildNextPage');

                self.bulb.initDefaultEvents();
                self.bulb.closeLoader();
                //self.bulb.loadCss(App.url+'/wp-content/uploads/elementor/css/post-' + this.newContainer.dataset.id + '.css?ver=1489414079');


                let initOffetY = 0;
                if(_this.newContainer.dataset.namespace == 'default'){
                    initOffetY = Verge.viewportH();
                    /*
                    Utils.debug('-----> on change le background >'+initOffetY);
                    Utils.debug(self.bulb);
                    if(self.bulb.pageBg){
                        $('.background').css('backgroundImage', 'url('+self.bulb.pageBg.src+')');
                    } else {
                        $('.background').css('backgroundImage', 'none');
                    }
                    */
                }





                $(this.oldContainer).hide();
                $(self.bulb.options.containerScrollable).trigger('SmoothPagesTransition:buildNextPage');


                ga('send', {
                    hitType: 'pageview',
                    page: location.pathname
                });

                //
                //setTimeout(function(){$('body').scrollTop(0);}, 1000);

                if(!self.bulb.lowVersion){
                    TweenMax.set( self.bulb.options.itemsScrollable, {y: initOffetY});
                    TweenMax.to( self.bulb.options.itemsScrollable, 0.5, {y: 0, delay: 1, onComplete: function(){
                        self.bulb.smoothscroll.scrollParallaxResize();
                    }});
                } else {
                    self.bulb.smoothscroll.scrollParallaxResize();
                }

                self.pageDefaultAppearTransition(this.newContainer, this);
            }
        });

    }



}

module.exports = SmoothPagesTransition;
